<template>
    <div class="w-full flex flex-column">
        <div v-if="getUserame" class="w-full flex flex-row surface-0 border-round-xl px-3 py-1 gap-2 align-items-center">
            <Avatar v-if="getAvatar" :image="getAvatar" size="medium" shape="circle" class="flex align-items-center"/>
            <span class="flex flex-1 text-700">{{'@'+getUserame}}</span>
            <Button :label="body[lang].unbind" text class="flex" icon="pi pi-undo" iconPos="left" @click="unbindTelegram" :disabled="isLoading" severity="info"/>
        </div>
        <div v-else class="flex flex-column">
            <span v-if="!getId" class="flex text-sm text-600 mb-2">{{ body[lang].subtitle }}</span>

            <ButtonLogin v-if="!getId" class="flex"
                mode="callback" 
                size="large"
                userpic="true" 
                request-access="write"
                :bot-username="bot_name" 
                @callback="bindTelegram" 
            />
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event'
import { ButtonLogin } from 'televue'
import { mapActions } from "vuex"

export default {
	data(){
		return{
            isLoading: false,
            body: {
                en: {
                    title: 'Telegram bind',
                    subtitle: 'Click login to bind Telegram',
                    unbind: 'Unbind',
                },
                ru: {
                    title: 'Привязка Telegram',
                    subtitle: 'Нажмите войти для привязки Telegram',
                    unbind: 'Отвязать',
                }
            },
            messeges: {
                en:{
                    success: 'Success',
                    binded: 'Successful bind',
                    unbinded: 'Successful unbind',
                    error: 'Error',
                },
                ru:{
                    success: 'Успех',
                    binded: 'Телеграм успешно привязан',
                    unbinded: 'Телеграм успешно отвязан',
                    error: 'Ошибка',
                }
            },
            bot_name: 'paywave_auth_bot',
            id: null,
            res_id: null,
            res_username: null,
            res_photo_url: null,
            reset: false,
		}
	},
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        userTelegram: function () { return this.$store.getters.StateTelegramUsername },
        getAvatar(){
            if(this.res_photo_url) return this.res_photo_url // привязанный
            else if(this.userPhoto && !this.reset) return this.userPhoto // взятый из props
            else return null
        },
        getUserame(){
            if(this.res_username) return this.res_username // привязанный
            else if(this.userTelegram && !this.reset) return this.userTelegram // взятый из props
            else return null
        },
        getId(){
            if(this.res_id) return this.res_id // привязанный
            else if(this.id && !this.reset) return this.id // взятый из props
            else return null
        },
        bot_name() {
            return (process.env.VUE_APP_AUTH_BOT) ? this.bot_name = process.env.VUE_APP_AUTH_BOT : this.bot_name
        }
    },
    components: {
        ButtonLogin
    },
	methods: {
		...mapActions(['ActionTgBind', 'ActionTgUnbind']),
        async bindTelegram(user){
            this.isLoading = true
            this.event.send('bindTg')

            try {
                const login = await this.ActionTgBind(user).then(res=>res)
                if(login.result && login.data){
                    this.showMess('success', this.messeges[this.lang].success, this.messeges[this.lang].binded) 
                    this.res_id = user.id
                    this.res_username = user.username
                    this.res_photo_url = user.photo_url
                    this.isLoading = false
                } else {
                    this.isLoading = false
                    if(login.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', this.messeges[this.lang].error, login.errors[i])
                        }
                    } else this.showMess('error', this.messeges[this.lang].error, 'Bind Error')
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Bind Error')
                this.isLoading = false
            }
        },
        async unbindTelegram(){
            const username = this.getUserame
            if(!username) return

            this.isLoading = true
            this.event.send('unbindTg')

            try {
                const unbind = await this.ActionTgUnbind({username:username}).then(res=>res)
                if(unbind.result && unbind.data){
                    this.showMess('success', this.messeges[this.lang].success, this.messeges[this.lang].unbinded) 
                    this.res_id = null
                    this.res_username = null
                    this.res_photo_url = null
                    this.isLoading = false
                    this.reset = true
                } else {
                    this.isLoading = false
                    if(unbind.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', this.messeges[this.lang].error, unbind.errors[i])
                        }
                    } else this.showMess('error', this.messeges[this.lang].error, 'Unbind Error')
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Unbind Error')
                this.isLoading = false
            }
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
	},
	async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
	}
}
</script>